import { Injectable, ComponentFactoryResolver, ApplicationRef, Injector, Component, HostListener, ElementRef, Input, Directive, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';

function AyudaCallMeBackComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "p", 20);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, " ");
} }
function AyudaEmailComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "p", 20);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, " ");
} }
function AyudaMenuComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵlistener("click", function AyudaMenuComponent_div_10_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r4.selectItem($event)); });
    ɵngcc0.ɵɵelementStart(1, "span", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "span", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.labels == null ? null : ctx_r0.labels.cmbChannelText);
} }
function AyudaMenuComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵlistener("click", function AyudaMenuComponent_ng_container_11_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r6.initiateWhatsApp()); });
    ɵngcc0.ɵɵelementStart(2, "span", 12);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "span", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.labels == null ? null : ctx_r1.labels.whatsAppChannelText);
} }
function AyudaMenuComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵlistener("click", function AyudaMenuComponent_div_12_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r8.initiateChat()); });
    ɵngcc0.ɵɵelementStart(1, "span", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "span", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.labels == null ? null : ctx_r2.labels.chatChannelText);
} }
function AyudaMenuComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵlistener("click", function AyudaMenuComponent_div_13_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r10.selectItem($event)); });
    ɵngcc0.ɵɵelementStart(1, "span", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "span", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.labels == null ? null : ctx_r3.labels.emailChannelText);
} }
const _c0 = ["ayudaTerms", ""];
const AyudaChannel = {
    CallMeBack: 'callmeback',
    Email: 'email',
    Chat: 'chat',
    WhatsApp: 'whatsapp',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AyudaEventService {
    constructor() {
        this.eventSubject = new Subject();
        this.formSubmitEventSubject = new Subject();
        /**
         * Subscribe to all the channel selection events
         *
         */
        this.channelSelection$ = this.eventSubject.asObservable();
        /**
         * Subscribe to all the form submission events
         *
         */
        this.formSubmitEvent$ = this.formSubmitEventSubject.asObservable();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    setEvent(event) {
        this.eventSubject.next(event);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    setFormSubmitEvent(event) {
        this.formSubmitEventSubject.next(event);
    }
}
AyudaEventService.ɵfac = function AyudaEventService_Factory(t) { return new (t || AyudaEventService)(); };
AyudaEventService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AyudaEventService, factory: AyudaEventService.ɵfac });
/** @nocollapse */
AyudaEventService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AyudaEventService, [{
        type: Injectable
    }], function () { return []; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AyudaEventService.prototype.eventSubject;
    /**
     * @type {?}
     * @private
     */
    AyudaEventService.prototype.formSubmitEventSubject;
    /**
     * Subscribe to all the channel selection events
     *
     * @type {?}
     */
    AyudaEventService.prototype.channelSelection$;
    /**
     * Subscribe to all the form submission events
     *
     * @type {?}
     */
    AyudaEventService.prototype.formSubmitEvent$;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AyudaLabelModel {
    constructor() {
        this.buttonText = 'Ayuda';
        this.chatBoxTitle = 'iTe ayudamos!';
        this.chatBoxSubTitle = 'Elige cómo quieres contactar:';
        this.cmbChannelText = 'Te llamamos gratis';
        this.chatChannelText = 'Chat';
        this.emailChannelText = 'Email';
        this.whatsAppChannelText = 'WhatsApp';
    }
}
if (false) {
    /** @type {?} */
    AyudaLabelModel.prototype.buttonText;
    /** @type {?} */
    AyudaLabelModel.prototype.chatBoxTitle;
    /** @type {?} */
    AyudaLabelModel.prototype.chatBoxSubTitle;
    /** @type {?} */
    AyudaLabelModel.prototype.cmbChannelText;
    /** @type {?} */
    AyudaLabelModel.prototype.chatChannelText;
    /** @type {?} */
    AyudaLabelModel.prototype.emailChannelText;
    /** @type {?} */
    AyudaLabelModel.prototype.whatsAppChannelText;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ChannelVisibilityModel {
    constructor() {
        this.isChatEnabled = false;
        this.isEmailEnabled = false;
        this.isCMBEnabled = false;
        this.isWhatAppEnabled = false;
    }
}
if (false) {
    /** @type {?} */
    ChannelVisibilityModel.prototype.isChatEnabled;
    /** @type {?} */
    ChannelVisibilityModel.prototype.isEmailEnabled;
    /** @type {?} */
    ChannelVisibilityModel.prototype.isCMBEnabled;
    /** @type {?} */
    ChannelVisibilityModel.prototype.isWhatAppEnabled;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AyudaTextModel {
}
if (false) {
    /** @type {?} */
    AyudaTextModel.prototype.telephoneChannelFinishMessageText;
    /** @type {?} */
    AyudaTextModel.prototype.emailChannelFinishMessageText;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AyudaSetting {
    constructor() {
        this.channelVisibility = new ChannelVisibilityModel();
        this.labels = new AyudaLabelModel();
        this.textMessage = new AyudaTextModel();
    }
}
if (false) {
    /** @type {?} */
    AyudaSetting.prototype.channelVisibility;
    /** @type {?} */
    AyudaSetting.prototype.labels;
    /** @type {?} */
    AyudaSetting.prototype.textMessage;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AyudaService {
    constructor() {
        this.defaultSettings = new AyudaSetting();
        this.ayudaSettingSubject = new Subject();
        this.ayudaSetting$ = this.ayudaSettingSubject.asObservable();
    }
    /**
     * @param {?} ayudaSetting
     * @return {?}
     */
    updateConfig(ayudaSetting) {
        /** @type {?} */
        const setting = Object.assign({}, this.defaultSettings, ayudaSetting);
        this.finishMessageSetting = setting.textMessage;
        this.ayudaSettingSubject.next(setting);
    }
}
AyudaService.ɵfac = function AyudaService_Factory(t) { return new (t || AyudaService)(); };
AyudaService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AyudaService, factory: AyudaService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AyudaService, [{
        type: Injectable
    }], function () { return []; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AyudaService.prototype.defaultSettings;
    /**
     * @type {?}
     * @private
     */
    AyudaService.prototype.ayudaSettingSubject;
    /** @type {?} */
    AyudaService.prototype.ayudaSetting$;
    /** @type {?} */
    AyudaService.prototype.finishMessageSetting;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AyudaFormDataModel {
    constructor() {
        this.callerName = '';
        this.callerEmail = '';
        this.callerTelephoneNumber = '';
        this.message = '';
    }
}
if (false) {
    /** @type {?} */
    AyudaFormDataModel.prototype.callerName;
    /** @type {?} */
    AyudaFormDataModel.prototype.callerTelephoneNumber;
    /** @type {?} */
    AyudaFormDataModel.prototype.callerEmail;
    /** @type {?} */
    AyudaFormDataModel.prototype.message;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AyudaFormSubmitEvent {
}
if (false) {
    /** @type {?} */
    AyudaFormSubmitEvent.prototype.channel;
    /** @type {?} */
    AyudaFormSubmitEvent.prototype.formData;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ErrorMessageConstant {
}
ErrorMessageConstant.ALL_FIELD_REQUIRED_ERROR = 'Por favor, rellena todos los campos correctamente';
if (false) {
    /** @type {?} */
    ErrorMessageConstant.ALL_FIELD_REQUIRED_ERROR;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function AyudaChannelSelection() { }
if (false) {
    /** @type {?} */
    AyudaChannelSelection.prototype.channel;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
class AyudaConfig {
}
if (false) {
    /** @type {?} */
    AyudaConfig.prototype.messageTitle;
    /** @type {?} */
    AyudaConfig.prototype.messageText;
    /** @type {?} */
    AyudaConfig.prototype.data;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AyudaInjector {
    /**
     * @param {?} _parentInjector
     * @param {?} _additionalTokens
     */
    constructor(_parentInjector, _additionalTokens) {
        this._parentInjector = _parentInjector;
        this._additionalTokens = _additionalTokens;
    }
    /**
     * @param {?} token
     * @param {?=} notFoundValue
     * @param {?=} flags
     * @return {?}
     */
    get(token, notFoundValue, flags) {
        /** @type {?} */
        const value = this._additionalTokens.get(token);
        if (value)
            return value;
        return this._parentInjector.get(token, notFoundValue);
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    AyudaInjector.prototype._parentInjector;
    /**
     * @type {?}
     * @private
     */
    AyudaInjector.prototype._additionalTokens;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ChannelSelectionService {
    /**
     * @param {?} eventStore
     */
    constructor(eventStore) {
        this.eventStore = eventStore;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    postEvent(event) {
        this.eventStore.setEvent(event);
    }
    /**
     * @return {?}
     */
    emailChannelSelected() {
        this.postEvent({ channel: AyudaChannel.Email });
    }
    /**
     * @return {?}
     */
    cmbChannelSelected() {
        this.postEvent({ channel: AyudaChannel.CallMeBack });
    }
    /**
     * @return {?}
     */
    chatChannelSelected() {
        this.postEvent({ channel: AyudaChannel.Chat });
    }
    /**
     * @return {?}
     */
    whatsAppChannelSelected() {
        this.postEvent({ channel: AyudaChannel.WhatsApp });
    }
}
ChannelSelectionService.ɵfac = function ChannelSelectionService_Factory(t) { return new (t || ChannelSelectionService)(ɵngcc0.ɵɵinject(AyudaEventService)); };
ChannelSelectionService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ChannelSelectionService, factory: ChannelSelectionService.ɵfac });
/** @nocollapse */
ChannelSelectionService.ctorParameters = () => [
    { type: AyudaEventService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ChannelSelectionService, [{
        type: Injectable
    }], function () { return [{ type: AyudaEventService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    ChannelSelectionService.prototype.eventStore;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AyudaUiService {
    /**
     * @param {?} componentFactoryResolver
     * @param {?} appRef
     * @param {?} injector
     * @param {?} channelSelectionService
     */
    constructor(componentFactoryResolver, appRef, injector, channelSelectionService) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
        this.channelSelectionService = channelSelectionService;
        this.actionListenerSubject = new Subject();
        this.title_history = [''];
    }
    /**
     * @return {?}
     */
    get isDesktop() {
        return !(window.innerWidth < 992);
    }
    /**
     * @return {?}
     */
    get actionListener$() {
        return this.actionListenerSubject.asObservable();
    }
    /**
     * @param {?} component
     * @param {?=} id
     * @param {?=} data
     * @return {?}
     */
    loadComponent(component, id, data) {
        // let wrappers = document.querySelectorAll('.help-box .wrapper');/
        /** @type {?} */
        let wrappers = document.querySelectorAll('.help-wrapper');
        for (var i = 0; i < wrappers.length; i++) {
            /** @type {?} */
            let el = wrappers[i];
            if (id) {
                el.classList.add(id);
            }
            /** @type {?} */
            let componentRef = this.componentFactoryResolver
                .resolveComponentFactory(component)
                .create(new AyudaInjector(this.injector, (new WeakMap()).set(AyudaConfig, data)));
            /** @type {?} */
            let dom_el = ((/** @type {?} */ (componentRef.hostView))).rootNodes[0];
            /** @type {?} */
            let new_el = document.createElement('div');
            /** @type {?} */
            let inst = ((/** @type {?} */ (componentRef.instance)));
            /** @type {?} */
            let title = inst.title;
            /** @type {?} */
            let is_last_page = inst.is_last;
            //is_first_page = el.getElementsByClassName('help-container').length == 0
            //let is_first_page = el.getElementsByClassName('help-container').length == 1;
            this.title_history.push(title);
            this.appRef.attachView(componentRef.hostView);
            /* adds new help-container, inserts component div and moves pagess */
            //new_el.className = 'help-container help-method block-wrapper'
            new_el.className = 'help-container help-method animate';
            new_el.setAttribute('style', 'display:block;');
            new_el.setAttribute('id', id);
            //if (!is_first_page) new_el.classList.add('out-left')
            new_el.appendChild(dom_el);
            el.appendChild(new_el);
            setTimeout((/**
             * @return {?}
             */
            () => this.movePages('forward', is_last_page)), 0);
        }
    }
    /**
     * @param {?} type
     * @param {?=} is_last
     * @return {?}
     */
    movePages(type, is_last) {
        // let wrappers = document.querySelectorAll('.help-box .wrapper')/
        /** @type {?} */
        let wrappers = document.querySelectorAll('.help-wrapper');
        for (var i = 0; i < wrappers.length; i++) {
            /** @type {?} */
            let el = wrappers[i];
            /** @type {?} */
            let pages_length = el.getElementsByClassName('help-container').length;
            if (pages_length) {
                /** @type {?} */
                let first = (/** @type {?} */ (el.getElementsByClassName('help-container')[pages_length - 2]));
                /** @type {?} */
                let last = (/** @type {?} */ (el.getElementsByClassName('help-container')[pages_length - 1]));
                /** @type {?} */
                let first_do = 'remove';
                /** @type {?} */
                let last_do = 'add';
                if (type === 'forward') {
                    first_do = 'add';
                    last_do = 'remove';
                }
                // last.classList[last_do]('out-left');
                last.classList[last_do]('outside');
                if (first) {
                    // first.classList[first_do]('out-right');
                    first.classList[first_do]('out-to-left');
                }
                if (type === 'backward') {
                    last.parentNode.removeChild(last);
                    this.title_history.pop();
                }
                // if (is_last) {
                //   this.unsetArrow()
                // }
                // else {
                //   this.setArrow()
                // }
                // this.setTitle()
            }
        }
    }
    /**
     * @return {?}
     */
    setTitle() {
        // let title_element = document.querySelectorAll('.help-box .help-title p');
        // let title_element = document.querySelectorAll('.help-wrapper .help-container .help-title p');
        // let title = this.title_history[this.title_history.length - 1];
        // if (typeof title === 'undefined') title = '';
        // for (var i = 0; i < title_element.length; i++) {
        //   let t_e = title_element[i];
        //   t_e.innerHTML = title;
        // }
    }
    /**
     * @return {?}
     */
    setArrow() {
        // //let wrappers = document.querySelectorAll('.help-box .wrapper');
        // let wrappers = document.querySelectorAll('.help-wrapper .wrapper');
        // for (var i = 0; i < wrappers.length; i++) {
        //   let el = wrappers[i];
        //   let pages_length = el.getElementsByClassName('help-container').length;
        //   //let go_back_element = el.closest('.help-box').querySelectorAll('.help-title .go-back')[0];
        //   let go_back_element = el.querySelectorAll('.help-title .icon-arrow-left')[0];
        //   let add_remove = (pages_length > 1) ? 'remove' : 'add';
        //   go_back_element.classList[add_remove]('hdn');
        // }
    }
    /**
     * @return {?}
     */
    unsetArrow() {
        // let wrappers = document.querySelectorAll('.help-box .wrapper');
        // for (var i = 0; i < wrappers.length; i++) {
        //   let el = wrappers[i];
        //   let go_back_element = el.closest('.help-box').querySelectorAll('.help-title .go-back')[0];
        //   go_back_element.classList.add('hdn');
        // }
    }
    /**
     * @param {?=} componentClass
     * @return {?}
     */
    resetHelp(componentClass) {
        // help button visible
        /** @type {?} */
        const help_btns = document.querySelectorAll('.help-button-btn');
        for (let i = 0; i < help_btns.length; i++) {
            help_btns[i].setAttribute('style', 'opacity: 1;');
        }
        // remove classes from main helpbox container
        /** @type {?} */
        const help_wrappers = document.querySelectorAll('.help-wrapper');
        for (let i = 0; i < help_wrappers.length; i++) {
            help_wrappers[i].classList.remove(componentClass);
            // if (this.isDesktop)
            help_wrappers[i].classList.remove('desktop');
            // else
            help_wrappers[i].classList.remove('mobile');
            help_wrappers[i].classList.remove('in');
        }
        /** @type {?} */
        const help_menus = document.querySelectorAll('.help-wrapper .help-container.help-menu');
        for (let i = 0; i < help_menus.length; i++) {
            help_menus[i].classList.remove('out-to-left');
        }
        /** @type {?} */
        const help_containers = document.querySelectorAll('.help-wrapper .help-container.help-method');
        for (let i = 0; i < help_containers.length; i++) {
            help_containers[i].parentNode.removeChild(help_containers[i]);
        }
    }
    /**
     * @return {?}
     */
    initiateWhatsApp() {
        // this.clickThroughService.saveWhatsAppCmbCounter().pipe(take(1)).subscribe({
        //     next: (x) => {
        //         // counter saved
        //     }
        // });
        // this.configService.showUnloadNotification = false;
        // this.trackingService.pushAyudaData('whatsapp');
        // this.windowService.navigate('whatsapp://send?text=Hola%20Rastreator&phone=34611056669');
        this.channelSelectionService.whatsAppChannelSelected();
    }
    /**
     * @return {?}
     */
    initiateChat() {
        // this.configService.saveLiveChatButton();
        // this.vendorFacade.startSnapEngageChat();
        // this.trackingService.pushAyudaData('chat');
        if (typeof SnapEngage !== 'undefined') {
            SnapEngage.startLink();
        }
        else {
            console.error('SnapEngage was either not loaded or not found');
        }
        this.channelSelectionService.chatChannelSelected();
    }
    /**
     * @return {?}
     */
    get channelVisibility() {
        return null;
        // return this.configService.pageContent && this.configService.pageContent.helpBoxSettings;
    }
    /**
     * @return {?}
     */
    get isHelpEnabled() {
        return true;
        //const cv = this.channelVisibility;
        //return cv && (cv.isHelpBoxCMBEnabled || cv.isHelpBoxEmailEnabled || cv.isHelpBoxChatEnabled || cv.isHelpBoxWhatAppEnabled);
    }
}
AyudaUiService.ɵfac = function AyudaUiService_Factory(t) { return new (t || AyudaUiService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ChannelSelectionService)); };
AyudaUiService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AyudaUiService, factory: AyudaUiService.ɵfac });
/** @nocollapse */
AyudaUiService.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ApplicationRef },
    { type: Injector },
    { type: ChannelSelectionService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AyudaUiService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.Injector }, { type: ChannelSelectionService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AyudaUiService.prototype.actionListenerSubject;
    /** @type {?} */
    AyudaUiService.prototype.title_history;
    /** @type {?} */
    AyudaUiService.prototype.results;
    /** @type {?} */
    AyudaUiService.prototype.componentFactoryResolver;
    /**
     * @type {?}
     * @private
     */
    AyudaUiService.prototype.appRef;
    /**
     * @type {?}
     * @private
     */
    AyudaUiService.prototype.injector;
    /**
     * @type {?}
     * @private
     */
    AyudaUiService.prototype.channelSelectionService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EmailValidationService {
    /**
     * @param {?} email
     * @return {?}
     */
    isValid(email) {
        /** @type {?} */
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
}
EmailValidationService.ɵfac = function EmailValidationService_Factory(t) { return new (t || EmailValidationService)(); };
EmailValidationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: EmailValidationService, factory: EmailValidationService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EmailValidationService, [{
        type: Injectable
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PhoneValidationService {
    /**
     * @param {?} phone
     * @return {?}
     */
    isValid(phone) {
        if (!phone) {
            return false;
        }
        if (phone.length != 9) {
            return false;
        }
        if (isNaN(parseInt(phone))) {
            return false;
        }
        /** @type {?} */
        var firstDigit = parseInt(phone.substr(0, 1));
        if (firstDigit < 6 || firstDigit > 9) {
            return false;
        }
        return true;
    }
    /**
     * @private
     * @param {?} inputText
     * @param {?} pattern
     * @return {?}
     */
    isValidPhone(inputText, pattern) {
        /** @type {?} */
        let regEx = new RegExp(pattern);
        return regEx.test(inputText);
    }
    /**
     * @param {?} phoneNumber
     * @param {?=} customPattern
     * @return {?}
     */
    isValidPhoneNumber(phoneNumber, customPattern) {
        /** @type {?} */
        const DEFAULT_PHONE_PATTERN = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{3,4}$/;
        return this.isValidPhone(phoneNumber, customPattern || DEFAULT_PHONE_PATTERN);
    }
}
PhoneValidationService.ɵfac = function PhoneValidationService_Factory(t) { return new (t || PhoneValidationService)(); };
PhoneValidationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PhoneValidationService, factory: PhoneValidationService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PhoneValidationService, [{
        type: Injectable
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RegexValidationService {
    /**
     * Matches the pattern against the inputText
     *
     * @param {?} inputText
     * @param {?} pattern
     * @return {?}
     */
    match(inputText, pattern) {
        /** @type {?} */
        let regEx = new RegExp(pattern);
        return regEx.test(inputText);
    }
}
RegexValidationService.ɵfac = function RegexValidationService_Factory(t) { return new (t || RegexValidationService)(); };
RegexValidationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: RegexValidationService, factory: RegexValidationService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RegexValidationService, [{
        type: Injectable
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ValidationService {
    /**
     * @param {?} regexValidator
     */
    constructor(regexValidator) {
        this.regexValidator = regexValidator;
    }
    /**
     * @param {?} phoneNumber
     * @param {?=} customPattern
     * @return {?}
     */
    isValidPhoneNumber(phoneNumber, customPattern) {
        /** @type {?} */
        const DEFAULT_PHONE_PATTERN = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{3,4}$/;
        return this.regexValidator.match(phoneNumber, customPattern || DEFAULT_PHONE_PATTERN);
    }
    /**
     * @param {?} name
     * @return {?}
     */
    isValidName(name) {
        /** @type {?} */
        const DEFAULT_NAME_PATTERN = /^[a-zA-Z ]{2,30}$/;
        return this.regexValidator.match(name, DEFAULT_NAME_PATTERN);
    }
}
ValidationService.ɵfac = function ValidationService_Factory(t) { return new (t || ValidationService)(ɵngcc0.ɵɵinject(RegexValidationService)); };
ValidationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ValidationService, factory: ValidationService.ɵfac });
/** @nocollapse */
ValidationService.ctorParameters = () => [
    { type: RegexValidationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidationService, [{
        type: Injectable
    }], function () { return [{ type: RegexValidationService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    ValidationService.prototype.regexValidator;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputValidationService {
    /**
     * @param {?} validationService
     * @param {?} emailValidationService
     * @param {?} phoneValidationService
     */
    constructor(validationService, emailValidationService, phoneValidationService) {
        this.validationService = validationService;
        this.emailValidationService = emailValidationService;
        this.phoneValidationService = phoneValidationService;
    }
    /**
     * @param {?} model
     * @return {?}
     */
    isValidCMBInput(model) {
        if (model.callerName == null || model.callerTelephoneNumber == null) {
            return false;
        }
        if (!this.validationService.isValidName(model.callerName)) {
            return false;
        }
        else if (!this.phoneValidationService.isValidPhoneNumber(model.callerTelephoneNumber)) {
            return false;
        }
        else if (!this.phoneValidationService.isValid(model.callerTelephoneNumber)) {
            return false;
        }
        return true;
    }
    /**
     * @param {?} model
     * @return {?}
     */
    isValidEmailInput(model) {
        if (model.callerName == null || model.callerEmail == null || model.message == null) {
            return false;
        }
        if (!this.validationService.isValidName(model.callerName)) {
            return false;
        }
        else if (!this.emailValidationService.isValid(model.callerEmail)) {
            return false;
        }
        else if (model.message.trim().length == 0) {
            return false;
        }
        return true;
    }
}
InputValidationService.ɵfac = function InputValidationService_Factory(t) { return new (t || InputValidationService)(ɵngcc0.ɵɵinject(ValidationService), ɵngcc0.ɵɵinject(EmailValidationService), ɵngcc0.ɵɵinject(PhoneValidationService)); };
InputValidationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: InputValidationService, factory: InputValidationService.ɵfac });
/** @nocollapse */
InputValidationService.ctorParameters = () => [
    { type: ValidationService },
    { type: EmailValidationService },
    { type: PhoneValidationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputValidationService, [{
        type: Injectable
    }], function () { return [{ type: ValidationService }, { type: EmailValidationService }, { type: PhoneValidationService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    InputValidationService.prototype.validationService;
    /**
     * @type {?}
     * @private
     */
    InputValidationService.prototype.emailValidationService;
    /**
     * @type {?}
     * @private
     */
    InputValidationService.prototype.phoneValidationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AyudaFinishComponent {
    /**
     * @param {?} data
     * @param {?} injector
     */
    constructor(data, injector) {
        this.data = data;
        this.injector = injector;
        this.is_last = true;
    }
    /**
     * @return {?}
     */
    closeHelp() {
        this.injector.resetHelp("help");
    }
}
AyudaFinishComponent.ɵfac = function AyudaFinishComponent_Factory(t) { return new (t || AyudaFinishComponent)(ɵngcc0.ɵɵdirectiveInject(AyudaConfig), ɵngcc0.ɵɵdirectiveInject(AyudaUiService)); };
AyudaFinishComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AyudaFinishComponent, selectors: [["help-finish"]], hostAttrs: [1, "help-finish"], decls: 11, vars: 2, consts: [[1, "help-title"], [1, "icon", "icon-arrow-left", "invisible"], [1, "invisible"], [1, "icon", "icon-cancel", 3, "click"], [1, "thanks", "text-center"], [1, "icon", "icon-check"]], template: function AyudaFinishComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "span", 1);
        ɵngcc0.ɵɵelementStart(2, "p", 2);
        ɵngcc0.ɵɵtext(3, "\u00A1Gracias!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵlistener("click", function AyudaFinishComponent_Template_span_click_4_listener() { return ctx.closeHelp(); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelement(6, "span", 5);
        ɵngcc0.ɵɵelementStart(7, "h2");
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelement(9, "br");
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.data == null ? null : ctx.data.messageTitle, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.data == null ? null : ctx.data.messageText, " ");
    } }, encapsulation: 2 });
/** @nocollapse */
AyudaFinishComponent.ctorParameters = () => [
    { type: AyudaConfig },
    { type: AyudaUiService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AyudaFinishComponent, [{
        type: Component,
        args: [{
                selector: 'help-finish',
                host: {
                    class: 'help-finish'
                },
                template: "<div class=\"help-title\">\r\n  <span class=\"icon icon-arrow-left invisible\"></span>\r\n  <p class=\"invisible\">\u00A1Gracias!</p>\r\n  <span class=\"icon icon-cancel\" (click)=\"closeHelp()\"></span>\r\n</div>\r\n<div class=\"thanks text-center\">\r\n  <span class=\"icon icon-check\"></span>\r\n  <h2>\r\n    {{data?.messageTitle}}\r\n    <br>\r\n    {{data?.messageText}}\r\n  </h2>\r\n</div>\r\n"
            }]
    }], function () { return [{ type: AyudaConfig }, { type: AyudaUiService }]; }, null); })();
if (false) {
    /** @type {?} */
    AyudaFinishComponent.prototype.is_last;
    /** @type {?} */
    AyudaFinishComponent.prototype.data;
    /** @type {?} */
    AyudaFinishComponent.prototype.injector;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AyudaCallMeBackComponent {
    /**
     * @param {?} ayudaService
     * @param {?} ayudaUiService
     * @param {?} inputValidationService
     * @param {?} ayudaEventService
     */
    constructor(ayudaService, ayudaUiService, inputValidationService, ayudaEventService) {
        this.ayudaService = ayudaService;
        this.ayudaUiService = ayudaUiService;
        this.inputValidationService = inputValidationService;
        this.ayudaEventService = ayudaEventService;
        this.title = "Te llamamos gratis";
        this.termsAccepted = false;
        this.message = "Te llamaremos lo más rápidamente posible dentro de la franja horaria que has elegido.";
        this.model = new AyudaFormDataModel();
    }
    /**
     * @return {?}
     */
    goBack() {
        // remove classes from main helpbox container
        /** @type {?} */
        let help_wrappers = document.querySelectorAll(".help-wrapper");
        for (let i = 0; i < help_wrappers.length; i++) {
            help_wrappers[i].classList.remove("callmeback");
        }
        /** @type {?} */
        let help_menus = document.querySelectorAll(".help-wrapper .help-container.help-menu");
        for (let i = 0; i < help_menus.length; i++) {
            i;
            help_menus[i].classList.remove("out-to-left");
        }
        /** @type {?} */
        let help_containers = document.querySelectorAll(".help-wrapper .help-container.help-method");
        for (let i = 0; i < help_containers.length; i++) {
            help_containers[i].parentNode.removeChild(help_containers[i]);
        }
    }
    /**
     * @return {?}
     */
    closeHelp() {
        this.ayudaUiService.resetHelp("callmeback");
    }
    /**
     * @return {?}
     */
    saveResponse() {
        /** @type {?} */
        let showError = false;
        if (!this.inputValidationService.isValidCMBInput(this.model)) {
            showError = true;
        }
        if (!this.termsAccepted) {
            showError = true;
        }
        if (showError) {
            this.errorMessage = ErrorMessageConstant.ALL_FIELD_REQUIRED_ERROR;
            return;
        }
        this.ayudaEventService.setFormSubmitEvent({
            channel: AyudaChannel.CallMeBack,
            formData: this.model
        });
        this.finish();
    }
    /**
     * @private
     * @return {?}
     */
    finish() {
        /** @type {?} */
        let finishMessage = this.ayudaService.finishMessageSetting.telephoneChannelFinishMessageText;
        if (finishMessage) {
            this.message = finishMessage;
        }
        this.ayudaUiService.loadComponent(AyudaFinishComponent, "thanksEmail-help", {
            "messageTitle": "¡Genial!",
            "messageText": this.message
        });
    }
}
AyudaCallMeBackComponent.ɵfac = function AyudaCallMeBackComponent_Factory(t) { return new (t || AyudaCallMeBackComponent)(ɵngcc0.ɵɵdirectiveInject(AyudaService), ɵngcc0.ɵɵdirectiveInject(AyudaUiService), ɵngcc0.ɵɵdirectiveInject(InputValidationService), ɵngcc0.ɵɵdirectiveInject(AyudaEventService)); };
AyudaCallMeBackComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AyudaCallMeBackComponent, selectors: [["ayuda-call-me-back"]], hostAttrs: [1, "help-call-me-back"], decls: 41, vars: 4, consts: [[1, "help-title"], [1, "icon", "icon-arrow-left", 3, "click"], [1, "icon", "icon-cancel", 3, "click"], [1, "header"], [1, "form-control", "input-placeholder-to-label", "negative"], [1, "has-float-label"], ["type", "text", "placeholder", "Nombre", 3, "ngModel", "ngModelChange"], ["type", "tel", "placeholder", "Tel\u00E9fono", "numbersOnly", "true", "maxlength", "9", 3, "ngModel", "ngModelChange"], [4, "ngIf"], [1, "divider"], [1, "form-control", "normal-checkbox", "orange"], [1, "normal-checkbox-container"], ["type", "checkbox", 3, "ngModel", "ngModelChange"], [1, "checkmark-container"], [1, "checkmark"], ["href", "https://www.rastreator.com/aviso-legal.aspx", "target", "_blank"], ["href", "https://www.rastreator.com/informacion-previa-del-mediador.aspx", "target", "_blank"], ["href", "https://www.rastreator.com/politica-de-privacidad.aspx", "target", "_blank"], [1, "btn", "solid-main", "submit", 3, "click"], ["ayudaTerms", ""], [1, "error-txt", 2, "color", "rgb(167, 0, 0)", "font-size", "12px", "margin", "-3px 8px 0px 0px", "font-weight", "600", "display", "block"]], template: function AyudaCallMeBackComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
        ɵngcc0.ɵɵlistener("click", function AyudaCallMeBackComponent_Template_span_click_1_listener() { return ctx.goBack(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "p");
        ɵngcc0.ɵɵtext(3, "Te llamamos gratis");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span", 2);
        ɵngcc0.ɵɵlistener("click", function AyudaCallMeBackComponent_Template_span_click_4_listener() { return ctx.closeHelp(); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(5, "div", 3)(6, "h2");
        ɵngcc0.ɵɵtext(7, "Uno de nuestros expertos");
        ɵngcc0.ɵɵelement(8, "br");
        ɵngcc0.ɵɵtext(9, "te llamar\u00E1 para ayudarte ;)");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(10, "div", 4)(11, "label", 5)(12, "input", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function AyudaCallMeBackComponent_Template_input_ngModelChange_12_listener($event) { return ctx.model.callerName = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "span");
        ɵngcc0.ɵɵtext(14, "Nombre");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(15, "div", 4)(16, "label", 5)(17, "input", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function AyudaCallMeBackComponent_Template_input_ngModelChange_17_listener($event) { return ctx.model.callerTelephoneNumber = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "span");
        ɵngcc0.ɵɵtext(19, "Tel\u00E9fono");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵtemplate(20, AyudaCallMeBackComponent_div_20_Template, 3, 1, "div", 8);
        ɵngcc0.ɵɵelementContainerStart(21);
        ɵngcc0.ɵɵelement(22, "div", 9);
        ɵngcc0.ɵɵelementStart(23, "div", 10)(24, "label", 11)(25, "input", 12);
        ɵngcc0.ɵɵlistener("ngModelChange", function AyudaCallMeBackComponent_Template_input_ngModelChange_25_listener($event) { return ctx.termsAccepted = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "div", 13);
        ɵngcc0.ɵɵelement(27, "span", 14);
        ɵngcc0.ɵɵelementStart(28, "span");
        ɵngcc0.ɵɵtext(29, "He le\u00EDdo y acepto el ");
        ɵngcc0.ɵɵelementStart(30, "a", 15);
        ɵngcc0.ɵɵtext(31, "Aviso Legal");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(32, ", ");
        ɵngcc0.ɵɵelementStart(33, "a", 16);
        ɵngcc0.ɵɵtext(34, "Info Previa");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(35, " y ");
        ɵngcc0.ɵɵelementStart(36, "a", 17);
        ɵngcc0.ɵɵtext(37, "la Pol\u00EDtica de Privacidad");
        ɵngcc0.ɵɵelementEnd()()()()();
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementStart(38, "button", 18);
        ɵngcc0.ɵɵlistener("click", function AyudaCallMeBackComponent_Template_button_click_38_listener() { return ctx.saveResponse(); });
        ɵngcc0.ɵɵtext(39, "Solicitar llamada");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(40, "div", 19);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(12);
        ɵngcc0.ɵɵproperty("ngModel", ctx.model.callerName);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.model.callerTelephoneNumber);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorMessage);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.termsAccepted);
    } }, dependencies: function () { return [ɵngcc1.NgIf, ɵngcc2.DefaultValueAccessor, ɵngcc2.CheckboxControlValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.MaxLengthValidator, ɵngcc2.NgModel, AyudaTermsComponent, NumbersOnlyInput]; }, encapsulation: 2 });
/** @nocollapse */
AyudaCallMeBackComponent.ctorParameters = () => [
    { type: AyudaService },
    { type: AyudaUiService },
    { type: InputValidationService },
    { type: AyudaEventService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AyudaCallMeBackComponent, [{
        type: Component,
        args: [{
                selector: 'ayuda-call-me-back',
                host: {
                    class: 'help-call-me-back'
                },
                template: "<div class=\"help-title\">\r\n  <span class=\"icon icon-arrow-left\" (click)=\"goBack()\"></span>\r\n  <p>Te llamamos gratis</p>\r\n  <span class=\"icon icon-cancel\" (click)=\"closeHelp()\"></span>\r\n</div>\r\n<div class=\"header\">\r\n  <h2>Uno de nuestros expertos<br />te llamar\u00E1 para ayudarte ;)</h2>\r\n</div>\r\n<div class=\"form-control input-placeholder-to-label negative\">\r\n  <label class=\"has-float-label\">\r\n    <input type=\"text\" placeholder=\"Nombre\" [(ngModel)]=\"model.callerName\" />\r\n    <span>Nombre</span>\r\n  </label>\r\n</div>\r\n<div class=\"form-control input-placeholder-to-label negative\">\r\n  <label class=\"has-float-label\">\r\n    <input type=\"tel\" placeholder=\"Tel\u00E9fono\" numbersOnly=\"true\" maxlength=\"9\" [(ngModel)]=\"model.callerTelephoneNumber\" />\r\n    <span>Tel\u00E9fono</span>\r\n  </label>\r\n</div>\r\n<div *ngIf=\"errorMessage\">\r\n  <p class=\"error-txt\" style=\"color: rgb(167, 0, 0); font-size: 12px; margin: -3px 8px 0px 0px; font-weight: 600; display: block;\">\r\n    {{errorMessage}}\r\n  </p>\r\n</div>\r\n<ng-container>\r\n  <div class=\"divider\"></div>\r\n  <div class=\"form-control normal-checkbox orange\">\r\n    <label class=\"normal-checkbox-container\">\r\n      <input type=\"checkbox\" [(ngModel)]=\"termsAccepted\" />\r\n      <div class=\"checkmark-container\">\r\n        <span class=\"checkmark\"></span>\r\n        <span>He le\u00EDdo y acepto el <a href=\"https://www.rastreator.com/aviso-legal.aspx\" target=\"_blank\">Aviso Legal</a>, <a href=\"https://www.rastreator.com/informacion-previa-del-mediador.aspx\" target=\"_blank\">Info Previa</a> y <a href=\"https://www.rastreator.com/politica-de-privacidad.aspx\" target=\"_blank\">la Pol\u00EDtica de Privacidad</a></span>\r\n      </div>\r\n    </label>\r\n  </div>\r\n</ng-container>\r\n<button class=\"btn solid-main submit\" (click)=\"saveResponse()\">Solicitar llamada</button>\r\n<div ayudaTerms></div>\r\n"
            }]
    }], function () { return [{ type: AyudaService }, { type: AyudaUiService }, { type: InputValidationService }, { type: AyudaEventService }]; }, null); })();
if (false) {
    /** @type {?} */
    AyudaCallMeBackComponent.prototype.title;
    /** @type {?} */
    AyudaCallMeBackComponent.prototype.model;
    /** @type {?} */
    AyudaCallMeBackComponent.prototype.errorMessage;
    /** @type {?} */
    AyudaCallMeBackComponent.prototype.termsAccepted;
    /** @type {?} */
    AyudaCallMeBackComponent.prototype.message;
    /**
     * @type {?}
     * @private
     */
    AyudaCallMeBackComponent.prototype.ayudaService;
    /**
     * @type {?}
     * @private
     */
    AyudaCallMeBackComponent.prototype.ayudaUiService;
    /**
     * @type {?}
     * @private
     */
    AyudaCallMeBackComponent.prototype.inputValidationService;
    /**
     * @type {?}
     * @private
     */
    AyudaCallMeBackComponent.prototype.ayudaEventService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AyudaEmailComponent {
    /**
     * @param {?} ayudaService
     * @param {?} injector
     * @param {?} inputValidationService
     * @param {?} ayudaEventService
     */
    constructor(ayudaService, injector, inputValidationService, ayudaEventService) {
        this.ayudaService = ayudaService;
        this.injector = injector;
        this.inputValidationService = inputValidationService;
        this.ayudaEventService = ayudaEventService;
        this.title = "Email";
        this.termsAccepted = false;
        this.message = "Muchas gracias por escribirnos.";
        this.model = new AyudaFormDataModel();
    }
    /**
     * @return {?}
     */
    goBack() {
        //remove classes from main helpbox container
        /** @type {?} */
        let help_wrappers = document.querySelectorAll(".help-wrapper");
        for (let i = 0; i < help_wrappers.length; i++) {
            help_wrappers[i].classList.remove("email");
        }
        /** @type {?} */
        let help_menus = document.querySelectorAll(".help-wrapper .help-container.help-menu");
        for (let i = 0; i < help_menus.length; i++) {
            i;
            help_menus[i].classList.remove("out-to-left");
        }
        /** @type {?} */
        let help_containers = document.querySelectorAll(".help-wrapper .help-container.help-method");
        for (let i = 0; i < help_containers.length; i++) {
            help_containers[i].parentNode.removeChild(help_containers[i]);
        }
    }
    /**
     * @return {?}
     */
    closeHelp() {
        this.injector.resetHelp("email");
    }
    /**
     * @return {?}
     */
    saveResponse() {
        /** @type {?} */
        let showError = false;
        if (!this.inputValidationService.isValidEmailInput(this.model)) {
            showError = true;
        }
        if (!this.termsAccepted) {
            showError = true;
        }
        if (showError) {
            this.errorMessage = ErrorMessageConstant.ALL_FIELD_REQUIRED_ERROR;
            return;
        }
        this.ayudaEventService.setFormSubmitEvent({
            channel: AyudaChannel.Email,
            formData: this.model
        });
        this.finish();
    }
    /**
     * @private
     * @return {?}
     */
    finish() {
        /** @type {?} */
        let finishMessage = this.ayudaService.finishMessageSetting.emailChannelFinishMessageText;
        if (finishMessage) {
            this.message = finishMessage;
        }
        this.injector.loadComponent(AyudaFinishComponent, "", {
            "messageTitle": "¡Mensaje recibido!",
            "messageText": this.message
        });
    }
}
AyudaEmailComponent.ɵfac = function AyudaEmailComponent_Factory(t) { return new (t || AyudaEmailComponent)(ɵngcc0.ɵɵdirectiveInject(AyudaService), ɵngcc0.ɵɵdirectiveInject(AyudaUiService), ɵngcc0.ɵɵdirectiveInject(InputValidationService), ɵngcc0.ɵɵdirectiveInject(AyudaEventService)); };
AyudaEmailComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AyudaEmailComponent, selectors: [["help-email"]], hostAttrs: [1, "help-email"], decls: 43, vars: 5, consts: [[1, "help-title"], [1, "icon", "icon-arrow-left", 3, "click"], [1, "icon", "icon-cancel", 3, "click"], [1, "header"], [1, "form-control", "input-placeholder-to-label", "negative"], [1, "has-float-label"], ["type", "text", "placeholder", "Nombre", 3, "ngModel", "ngModelChange"], ["type", "email", "placeholder", "Email", 3, "ngModel", "ngModelChange"], ["placeholder", "Mensaje", "cols", "5", "rows", "3", 3, "ngModel", "ngModelChange"], [4, "ngIf"], [1, "form-control", "normal-checkbox", "orange"], [1, "normal-checkbox-container"], ["type", "checkbox", 3, "ngModel", "ngModelChange"], [1, "checkmark-container"], [1, "checkmark"], ["href", "https://www.rastreator.com/aviso-legal.aspx", "target", "_blank"], ["href", "https://www.rastreator.com/informacion-previa-del-mediador.aspx", "target", "_blank"], ["href", "https://www.rastreator.com/politica-de-privacidad.aspx", "target", "_blank"], [1, "btn", "solid-main", "submit", 3, "click"], ["ayudaTerms", ""], [1, "error-txt", 2, "color", "rgb(167, 0, 0)", "font-size", "12px", "margin", "-3px 8px 0px 0px", "font-weight", "600", "display", "block"]], template: function AyudaEmailComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
        ɵngcc0.ɵɵlistener("click", function AyudaEmailComponent_Template_span_click_1_listener() { return ctx.goBack(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "p");
        ɵngcc0.ɵɵtext(3, "Email");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span", 2);
        ɵngcc0.ɵɵlistener("click", function AyudaEmailComponent_Template_span_click_4_listener() { return ctx.closeHelp(); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(5, "div", 3)(6, "h2");
        ɵngcc0.ɵɵtext(7, "Cu\u00E9ntanos c\u00F3mo podemos ayudarte");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(8, "div", 4)(9, "label", 5)(10, "input", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function AyudaEmailComponent_Template_input_ngModelChange_10_listener($event) { return ctx.model.callerName = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "span");
        ɵngcc0.ɵɵtext(12, "Nombre");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(13, "div", 4)(14, "label", 5)(15, "input", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function AyudaEmailComponent_Template_input_ngModelChange_15_listener($event) { return ctx.model.callerEmail = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "span");
        ɵngcc0.ɵɵtext(17, "Email");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(18, "div", 4)(19, "label", 5)(20, "textarea", 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function AyudaEmailComponent_Template_textarea_ngModelChange_20_listener($event) { return ctx.model.message = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "span");
        ɵngcc0.ɵɵtext(22, "Mensaje");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵtemplate(23, AyudaEmailComponent_div_23_Template, 3, 1, "div", 9);
        ɵngcc0.ɵɵelementContainerStart(24);
        ɵngcc0.ɵɵelementStart(25, "div", 10)(26, "label", 11)(27, "input", 12);
        ɵngcc0.ɵɵlistener("ngModelChange", function AyudaEmailComponent_Template_input_ngModelChange_27_listener($event) { return ctx.termsAccepted = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "div", 13);
        ɵngcc0.ɵɵelement(29, "span", 14);
        ɵngcc0.ɵɵelementStart(30, "span");
        ɵngcc0.ɵɵtext(31, "He le\u00EDdo y acepto el ");
        ɵngcc0.ɵɵelementStart(32, "a", 15);
        ɵngcc0.ɵɵtext(33, "Aviso Legal");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(34, ", ");
        ɵngcc0.ɵɵelementStart(35, "a", 16);
        ɵngcc0.ɵɵtext(36, "Info Previa");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(37, " y ");
        ɵngcc0.ɵɵelementStart(38, "a", 17);
        ɵngcc0.ɵɵtext(39, "la Pol\u00EDtica de Privacidad");
        ɵngcc0.ɵɵelementEnd()()()()();
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementStart(40, "button", 18);
        ɵngcc0.ɵɵlistener("click", function AyudaEmailComponent_Template_button_click_40_listener() { return ctx.saveResponse(); });
        ɵngcc0.ɵɵtext(41, "Enviar");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(42, "div", 19);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(10);
        ɵngcc0.ɵɵproperty("ngModel", ctx.model.callerName);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.model.callerEmail);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.model.message);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorMessage);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.termsAccepted);
    } }, dependencies: function () { return [ɵngcc1.NgIf, ɵngcc2.DefaultValueAccessor, ɵngcc2.CheckboxControlValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, AyudaTermsComponent]; }, encapsulation: 2 });
/** @nocollapse */
AyudaEmailComponent.ctorParameters = () => [
    { type: AyudaService },
    { type: AyudaUiService },
    { type: InputValidationService },
    { type: AyudaEventService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AyudaEmailComponent, [{
        type: Component,
        args: [{
                selector: 'help-email',
                host: {
                    class: 'help-email'
                },
                template: "<div class=\"help-title\">\r\n  <span class=\"icon icon-arrow-left\" (click)=\"goBack()\"></span>\r\n  <p>Email</p>\r\n  <span class=\"icon icon-cancel\" (click)=\"closeHelp()\"></span>\r\n</div>\r\n<div class=\"header\">\r\n  <h2>Cu\u00E9ntanos c\u00F3mo podemos ayudarte</h2>\r\n</div>\r\n<div class=\"form-control input-placeholder-to-label negative\">\r\n  <label class=\"has-float-label\">\r\n    <input type=\"text\" placeholder=\"Nombre\" [(ngModel)]=\"model.callerName\" />\r\n    <span>Nombre</span>\r\n  </label>\r\n</div>\r\n<div class=\"form-control input-placeholder-to-label negative\">\r\n  <label class=\"has-float-label\">\r\n    <input type=\"email\" placeholder=\"Email\" [(ngModel)]=\"model.callerEmail\" />\r\n    <span>Email</span>\r\n  </label>\r\n</div>\r\n<div class=\"form-control input-placeholder-to-label negative\">\r\n  <label class=\"has-float-label\">\r\n    <textarea placeholder=\"Mensaje\" cols=\"5\" rows=\"3\" [(ngModel)]=\"model.message\"></textarea>\r\n    <span>Mensaje</span>\r\n  </label>\r\n</div>\r\n<div *ngIf=\"errorMessage\">\r\n  <p class=\"error-txt\" style=\"color: rgb(167, 0, 0); font-size: 12px; margin: -3px 8px 0px 0px; font-weight: 600; display: block;\">\r\n    {{errorMessage}}\r\n  </p>\r\n</div>\r\n<ng-container>\r\n  <div class=\"form-control normal-checkbox orange\">\r\n    <label class=\"normal-checkbox-container\">\r\n      <input type=\"checkbox\" [(ngModel)]=\"termsAccepted\" />\r\n      <div class=\"checkmark-container\">\r\n        <span class=\"checkmark\"></span>\r\n        <span>He le\u00EDdo y acepto el <a href=\"https://www.rastreator.com/aviso-legal.aspx\" target=\"_blank\">Aviso Legal</a>, <a href=\"https://www.rastreator.com/informacion-previa-del-mediador.aspx\" target=\"_blank\">Info Previa</a> y <a href=\"https://www.rastreator.com/politica-de-privacidad.aspx\" target=\"_blank\">la Pol\u00EDtica de Privacidad</a></span>\r\n      </div>\r\n    </label>\r\n  </div>\r\n</ng-container>\r\n<button class=\"btn solid-main submit\" (click)=\"saveResponse()\">Enviar</button>\r\n<div ayudaTerms></div>\r\n"
            }]
    }], function () { return [{ type: AyudaService }, { type: AyudaUiService }, { type: InputValidationService }, { type: AyudaEventService }]; }, null); })();
if (false) {
    /** @type {?} */
    AyudaEmailComponent.prototype.title;
    /** @type {?} */
    AyudaEmailComponent.prototype.model;
    /** @type {?} */
    AyudaEmailComponent.prototype.errorMessage;
    /** @type {?} */
    AyudaEmailComponent.prototype.termsAccepted;
    /** @type {?} */
    AyudaEmailComponent.prototype.message;
    /**
     * @type {?}
     * @private
     */
    AyudaEmailComponent.prototype.ayudaService;
    /**
     * @type {?}
     * @private
     */
    AyudaEmailComponent.prototype.injector;
    /**
     * @type {?}
     * @private
     */
    AyudaEmailComponent.prototype.inputValidationService;
    /**
     * @type {?}
     * @private
     */
    AyudaEmailComponent.prototype.ayudaEventService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AyudaMenuComponent {
    /**
     * @param {?} ayudaService
     * @param {?} ayudaUiService
     * @param {?} channelSelectionService
     */
    constructor(ayudaService, ayudaUiService, channelSelectionService) {
        this.ayudaService = ayudaService;
        this.ayudaUiService = ayudaUiService;
        this.channelSelectionService = channelSelectionService;
        this.mobile = false; //this.configService.isMobileUI;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onResize(event) {
        this.mobile = false; // this.configService.isMobileUI;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.channelSubscription = this.ayudaService.ayudaSetting$.subscribe({
            next: (/**
             * @param {?} o
             * @return {?}
             */
            (o) => {
                if (o.channelVisibility) {
                    this.channelVisibility = Object.assign({}, this.channelVisibility, o.channelVisibility);
                }
                if (o.labels) {
                    this.labels = Object.assign({}, this.labels, o.labels);
                }
            })
        });
    }
    /**
     * @param {?} event
     * @return {?}
     */
    selectItem(event) {
        /** @type {?} */
        let target = event.target || event.srcElement || event.currentTarget;
        /** @type {?} */
        let 
        //clicked_item = target.closest(".item"),
        clicked_item = target.closest(".menu-item");
        /** @type {?} */
        let itemPage = clicked_item.dataset.item;
        this.ayudaUiService.loadComponent(this.getComponent(itemPage), itemPage);
    }
    /**
     * @return {?}
     */
    initiateWhatsApp() {
        this.ayudaUiService.initiateWhatsApp();
    }
    /**
     * @return {?}
     */
    initiateChat() {
        this.ayudaUiService.initiateChat();
    }
    /**
     * @param {?} name
     * @return {?}
     */
    getComponent(name) {
        /** @type {?} */
        let component = null;
        switch (true) {
            case (name === AyudaChannel.CallMeBack):
                component = AyudaCallMeBackComponent;
                //this.trackingService.pushAyudaData("tellamamos");
                this.channelSelectionService.cmbChannelSelected();
                break;
            case (name === AyudaChannel.Email):
                component = AyudaEmailComponent;
                //this.trackingService.pushAyudaData("email");
                this.channelSelectionService.emailChannelSelected();
                break;
        }
        return component;
    }
    /**
     * @return {?}
     */
    closeHelp() {
        this.ayudaUiService.resetHelp();
    }
    /**
     * @return {?}
     */
    goBack() {
        this.ayudaUiService.movePages("backward");
    }
    //get channelVisibility(): any {
    //    return this.ayudaUiService.channelVisibility;
    //}
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.channelSubscription) {
            this.channelSubscription.unsubscribe();
        }
    }
}
AyudaMenuComponent.ɵfac = function AyudaMenuComponent_Factory(t) { return new (t || AyudaMenuComponent)(ɵngcc0.ɵɵdirectiveInject(AyudaService), ɵngcc0.ɵɵdirectiveInject(AyudaUiService), ɵngcc0.ɵɵdirectiveInject(ChannelSelectionService)); };
AyudaMenuComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AyudaMenuComponent, selectors: [["help-menu"]], hostAttrs: [1, "help-menu"], hostBindings: function AyudaMenuComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function AyudaMenuComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, decls: 14, vars: 6, consts: [["data-id", "help-menu", 1, "help-container", "animate", "help-menu"], [1, "help-title"], [1, "icon", "icon-arrow-left", "go-back", "invisible", 3, "click"], [1, "icon", "icon-cancel", 3, "click"], [1, "header"], [1, "title"], [1, "subtitle"], ["class", "menu-item", "data-item", "callmeback", 3, "click", 4, "ngIf"], [4, "ngIf"], ["class", "menu-item", "data-id", "chat", 3, "click", 4, "ngIf"], ["class", "menu-item", "data-item", "email", 3, "click", 4, "ngIf"], ["data-item", "callmeback", 1, "menu-item", 3, "click"], [1, "text-item"], [1, "icon", "icon-arrow-right"], ["data-id", "whatsapp", 1, "menu-item", 3, "click"], ["data-id", "chat", 1, "menu-item", 3, "click"], ["data-item", "email", 1, "menu-item", 3, "click"]], template: function AyudaMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span", 2);
        ɵngcc0.ɵɵlistener("click", function AyudaMenuComponent_Template_span_click_2_listener() { return ctx.goBack(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "p");
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵlistener("click", function AyudaMenuComponent_Template_span_click_4_listener() { return ctx.closeHelp(); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(5, "div", 4)(6, "p", 5);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "p", 6);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(10, AyudaMenuComponent_div_10_Template, 4, 1, "div", 7);
        ɵngcc0.ɵɵtemplate(11, AyudaMenuComponent_ng_container_11_Template, 5, 1, "ng-container", 8);
        ɵngcc0.ɵɵtemplate(12, AyudaMenuComponent_div_12_Template, 4, 1, "div", 9);
        ɵngcc0.ɵɵtemplate(13, AyudaMenuComponent_div_13_Template, 4, 1, "div", 10);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate(ctx.labels == null ? null : ctx.labels.chatBoxTitle);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.labels == null ? null : ctx.labels.chatBoxSubTitle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.channelVisibility == null ? null : ctx.channelVisibility.isCMBEnabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mobile && (ctx.channelVisibility == null ? null : ctx.channelVisibility.isWhatAppEnabled));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.channelVisibility == null ? null : ctx.channelVisibility.isChatEnabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.channelVisibility == null ? null : ctx.channelVisibility.isEmailEnabled);
    } }, dependencies: [ɵngcc1.NgIf], encapsulation: 2 });
/** @nocollapse */
AyudaMenuComponent.ctorParameters = () => [
    { type: AyudaService },
    { type: AyudaUiService },
    { type: ChannelSelectionService }
];
AyudaMenuComponent.propDecorators = {
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AyudaMenuComponent, [{
        type: Component,
        args: [{
                selector: 'help-menu',
                host: {
                    class: 'help-menu'
                },
                template: "<div data-id=\"help-menu\" class=\"help-container animate help-menu\">\r\n  <div class=\"help-title\">\r\n    <span class=\"icon icon-arrow-left go-back invisible\" (click)=\"goBack()\"></span>\r\n    <p></p>\r\n    <span class=\"icon icon-cancel\" (click)=\"closeHelp()\"></span>\r\n  </div>\r\n  <div class=\"header\">\r\n    <p class=\"title\">{{labels?.chatBoxTitle}}</p>\r\n    <p class=\"subtitle\">{{labels?.chatBoxSubTitle}}</p>\r\n  </div>\r\n  <div class=\"menu-item\" data-item=\"callmeback\" (click)=\"selectItem($event)\" *ngIf=\"channelVisibility?.isCMBEnabled\">\r\n    <span class=\"text-item\">{{labels?.cmbChannelText}}</span>\r\n    <span class=\"icon icon-arrow-right\"></span>\r\n  </div>\r\n  <ng-container *ngIf=\"mobile && channelVisibility?.isWhatAppEnabled\">\r\n    <div class=\"menu-item\" data-id=\"whatsapp\" (click)=\"initiateWhatsApp()\">\r\n      <span class=\"text-item\">{{labels?.whatsAppChannelText}}</span>\r\n      <span class=\"icon icon-arrow-right\"></span>\r\n    </div>\r\n  </ng-container>\r\n  <div class=\"menu-item\" data-id=\"chat\" (click)=\"initiateChat()\" *ngIf=\"channelVisibility?.isChatEnabled\">\r\n    <span class=\"text-item\">{{labels?.chatChannelText}}</span>\r\n    <span class=\"icon icon-arrow-right\"></span>\r\n  </div>\r\n  <div class=\"menu-item\" data-item=\"email\" (click)=\"selectItem($event)\" *ngIf=\"channelVisibility?.isEmailEnabled\">\r\n    <span class=\"text-item\">{{labels?.emailChannelText}}</span>\r\n    <span class=\"icon icon-arrow-right\"></span>\r\n  </div>\r\n</div>\r\n\r\n"
            }]
    }], function () { return [{ type: AyudaService }, { type: AyudaUiService }, { type: ChannelSelectionService }]; }, { 
    /**
     * @param {?} event
     * @return {?}
     */
    onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AyudaMenuComponent.prototype.channelSubscription;
    /** @type {?} */
    AyudaMenuComponent.prototype.mobile;
    /** @type {?} */
    AyudaMenuComponent.prototype.channelVisibility;
    /** @type {?} */
    AyudaMenuComponent.prototype.labels;
    /**
     * @type {?}
     * @private
     */
    AyudaMenuComponent.prototype.ayudaService;
    /** @type {?} */
    AyudaMenuComponent.prototype.ayudaUiService;
    /**
     * @type {?}
     * @private
     */
    AyudaMenuComponent.prototype.channelSelectionService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AyudaTermsComponent {
    constructor() {
    }
    /**
     * @return {?}
     */
    toggleTerms() {
        this.termsActive = !this.termsActive;
    }
}
AyudaTermsComponent.ɵfac = function AyudaTermsComponent_Factory(t) { return new (t || AyudaTermsComponent)(); };
AyudaTermsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AyudaTermsComponent, selectors: [["", "ayudaTerms", ""]], attrs: _c0, decls: 22, vars: 4, consts: [[1, "collapse"], [1, "collapse-trigger", 3, "click"], [1, "icon", "icon-chevron-down"], [1, "collapsed"], ["href", "mailto: tusderechos@rastreator.com"], ["href", "mailto: datospersonales@rastreator.com"], ["href", "https://www.rastreator.com/politica-de-privacidad.aspx", "target", "_blank"]], template: function AyudaTermsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "p", 1);
        ɵngcc0.ɵɵlistener("click", function AyudaTermsComponent_Template_p_click_1_listener() { return ctx.toggleTerms(); });
        ɵngcc0.ɵɵtext(2, "Recuerda revisar la informaci\u00F3n b\u00E1sica de privacidad ");
        ɵngcc0.ɵɵelement(3, "span", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3)(5, "p");
        ɵngcc0.ɵɵtext(6, " Los datos facilitados a ");
        ɵngcc0.ɵɵelementStart(7, "strong");
        ɵngcc0.ɵɵtext(8, "RASTREATOR COMPARADOR CORREDUR\u00CDA DE SEGUROS, S.L.U., corredor de seguros");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(9, " registrado en la DGSFP con n\u00BA J3257, con seguro responsabilidad civil contratado (C/ S\u00E1nchez Pacheco, 85, 28002 de Madrid \u2013 DPO ");
        ɵngcc0.ɵɵelementStart(10, "a", 4);
        ɵngcc0.ɵɵtext(11, "tusderechos@rastreator.com");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(12, ") ser\u00E1n tratados para prestarte el servicio que has solicitado.");
        ɵngcc0.ɵɵelement(13, "br")(14, "br");
        ɵngcc0.ɵɵtext(15, " Adem\u00E1s, tus datos podr\u00E1n ser comunicados a entidades colaboradoras de Rastreator, con la finalidad de proporcionarte el servicio. Dicho tratamiento se fundamenta en la necesidad de llevarlo a cabo para desarrollar la prestaci\u00F3n de dicho servicio. Puedes ejercer tus derechos de acceso, rectificaci\u00F3n, supresi\u00F3n y oposici\u00F3n, entre otros, dirigi\u00E9ndote por escrito a Rastreator al domicilio se\u00F1alado o a ");
        ɵngcc0.ɵɵelementStart(16, "a", 5);
        ɵngcc0.ɵɵtext(17, "datospersonales@rastreator.com");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(18, ". Para m\u00E1s informaci\u00F3n, visita nuestra ");
        ɵngcc0.ɵɵelementStart(19, "a", 6);
        ɵngcc0.ɵɵtext(20, "Pol\u00EDtica de Privacidad");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(21, ". ");
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassProp("active", ctx.termsActive);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("active", ctx.termsActive);
    } }, encapsulation: 2 });
/** @nocollapse */
AyudaTermsComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AyudaTermsComponent, [{
        type: Component,
        args: [{
                selector: '[ayudaTerms]',
                template: "<div class=\"collapse\">\r\n    <p class=\"collapse-trigger\" (click)=\"toggleTerms()\">Recuerda revisar la informaci\u00F3n b\u00E1sica de privacidad <span class=\"icon icon-chevron-down\" [class.active]=\"termsActive\"></span></p>\r\n    <div class=\"collapsed\" [class.active]=\"termsActive\">\r\n      <p>\r\n        Los datos facilitados a <strong>RASTREATOR COMPARADOR CORREDUR\u00CDA DE SEGUROS, S.L.U., corredor de seguros</strong> registrado en la DGSFP con n\u00BA J3257, con seguro responsabilidad civil contratado (C/ S\u00E1nchez Pacheco, 85, 28002 de Madrid \u2013 DPO <a href=\"mailto: tusderechos@rastreator.com\">tusderechos@rastreator.com</a>) ser\u00E1n tratados para prestarte el servicio que has solicitado.<br><br> Adem\u00E1s, tus datos podr\u00E1n ser comunicados a entidades colaboradoras de Rastreator, con la finalidad de proporcionarte el servicio. Dicho tratamiento se fundamenta en la necesidad de llevarlo a cabo para desarrollar la prestaci\u00F3n de dicho servicio. Puedes ejercer tus derechos de acceso, rectificaci\u00F3n, supresi\u00F3n y oposici\u00F3n, entre otros, dirigi\u00E9ndote por escrito a  Rastreator al domicilio se\u00F1alado o a <a href=\"mailto: datospersonales@rastreator.com\">datospersonales@rastreator.com</a>. Para m\u00E1s informaci\u00F3n, visita nuestra <a href=\"https://www.rastreator.com/politica-de-privacidad.aspx\" target=\"_blank\">Pol\u00EDtica de Privacidad</a>.\r\n      </p>\r\n    </div>\r\n  </div>\r\n"
            }]
    }], function () { return []; }, null); })();
if (false) {
    /** @type {?} */
    AyudaTermsComponent.prototype.termsActive;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AyudaComponent {
    //@HostBinding('class') hostClasses: string = "hidden-xs hidden-sm help-button-wrapper-desktop help-btn-pp";
    /**
     * @param {?} ayudaService
     * @param {?} elementRef
     * @param {?} ayudaUiService
     * @param {?} channelSelectionService
     */
    constructor(ayudaService, elementRef, ayudaUiService, channelSelectionService) {
        this.ayudaService = ayudaService;
        this.elementRef = elementRef;
        this.ayudaUiService = ayudaUiService;
        this.channelSelectionService = channelSelectionService;
        this.element_position = 0;
        this.scroll = (/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            //handle your scroll here
            //notice the 'odd' function assignment to a class field
            //this is used to be able to remove the event listener
            /** @type {?} */
            const window$ = ((/** @type {?} */ (window)));
            if (window$.innerWidth > 992) {
                //this.calculateMaxHeight();
                this.setHelpPosition();
            }
        });
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set displayMode(value) {
        this.dispMode = value;
    }
    /**
     * @return {?}
     */
    get displayMode() {
        if (!this.dispMode) {
            this.dispMode = 'desktop';
        }
        return this.dispMode;
    }
    //@HostListener('window:resize', ['$event'])
    //onResize(event): void {
    //    this.setButtonTitle();
    //}
    /**
     * @param {?} event
     * @return {?}
     */
    onScroll(event) {
        try {
            this.fixPosition();
        }
        catch (e) {
        }
    }
    /**
     * @return {?}
     */
    setHelpButtonHeight() {
        /** @type {?} */
        const window$ = ((/** @type {?} */ (window)));
        /** @type {?} */
        const footerElement = (/** @type {?} */ (document.querySelector('footer')));
        /** @type {?} */
        const helpButtonElement = (/** @type {?} */ (document.querySelector('.help-button.sticky')));
        /** @type {?} */
        let elementBottom = window$.outerHeight - (document.body.clientHeight - 32) - (footerElement.offsetHeight - 36);
        /** @type {?} */
        let scrollTop = document.body.scrollTop - 148;
        if (scrollTop > elementBottom) {
            /** @type {?} */
            const _aVal = 48;
            /** @type {?} */
            const _diffvalue = (scrollTop - elementBottom);
            /** @type {?} */
            const sumOfheight = _aVal + _diffvalue;
            /** @type {?} */
            let acutalHeight = sumOfheight.toString() + "px";
            helpButtonElement.style.bottom = acutalHeight;
        }
        else if (window$.outerWidth > 1900) {
            helpButtonElement.style.bottom = "228px";
        }
        else {
            helpButtonElement.style.bottom = "48px";
        }
    }
    /**
     * @return {?}
     */
    setHelpPosition() {
        /** @type {?} */
        let footerHeight = document.querySelector("footer").offsetHeight;
        if (footerHeight == 0) {
            footerHeight = 140;
        }
        /** @type {?} */
        const element = (/** @type {?} */ (document.querySelector('.help-button.sticky')));
        /** @type {?} */
        let _diffvalue = document.body.scrollHeight - document.body.clientHeight - footerHeight;
        /** @type {?} */
        let _scrollTop = document.body.scrollTop;
        if (_diffvalue < _scrollTop) {
            _diffvalue = _scrollTop - _diffvalue;
            element.style.bottom = (_diffvalue + 48) + "px";
        }
    }
    //calculateMaxHeight() {
    //  const window$ = (window as any);
    //  var h1_bottom_offset = window$.innerHeight - document.querySelector('h1').offsetTop - 36;
    //  const wrapper = document.querySelector('.help-wrapper') as HTMLElement;
    //  wrapper.style.maxHeight = h1_bottom_offset + "px";
    //}
    /**
     * @private
     * @return {?}
     */
    fixPosition() {
        /** @type {?} */
        const distance = 470;
        /** @type {?} */
        const //helpBtnPP.offsetTop,
        window$ = ((/** @type {?} */ (window)));
        /** @type {?} */
        const noticeContainer = (/** @type {?} */ (document.querySelector('.notice-container')));
        /** @type {?} */
        const elementOffset = noticeContainer.offsetTop;
        if (window$.pageYOffset >= distance) {
            this.help_box.classList.add("help-fixed");
        }
        else {
            this.help_box.classList.remove("help-fixed");
        }
        if (window$.pageYOffset >= elementOffset - 60) {
            this.help_box.classList.remove("help-fixed");
            this.help_box.classList.add("help-bottom");
        }
        else {
            this.help_box.classList.remove("help-bottom");
        }
    }
    /**
     * @private
     * @return {?}
     */
    setButtonTitle() {
        if (this.isMobile) {
            this.title = 'ayuda';
        }
        else {
            this.title = 'Necesitas ayuda';
        }
    }
    /**
     * @return {?}
     */
    get isMobile() {
        return !this.ayudaUiService.isDesktop;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        window.addEventListener('scroll', this.scroll, true); //third parameter
        this.isHelpSectionEnabled = this.ayudaUiService.isHelpEnabled;
        //if (this.displayMode === 'mobile') {
        //    this.hostClasses = "hidden-md hidden-lg help-button-wrapper-mobile";
        //}
        //this.setButtonTitle();
        if (window.innerWidth > 992) {
            this.setHelpPosition();
        }
        //this.setHelpPosition();
        this.settingSub = this.ayudaService.ayudaSetting$.subscribe({
            next: (/**
             * @param {?} o
             * @return {?}
             */
            (o) => {
                this.title = o.labels.buttonText;
            })
        });
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.help_box = this.elementRef.nativeElement;
        this.help_box.addEventListener('animationend', (/**
         * @param {?} e
         * @return {?}
         */
        (e) => {
            if (e.animationName === 'close-down' || e.animationName === 'close-up') {
                this.ayudaUiService.resetHelp();
            }
        }), true);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.settingSub) {
            this.settingSub.unsubscribe();
        }
    }
    /**
     * @return {?}
     */
    passedTop() {
        /** @type {?} */
        let help_box_position = this.help_box.getBoundingClientRect().top + window.pageYOffset;
        return !(window.pageYOffset < help_box_position);
    }
    /**
     * @return {?}
     */
    passedBottom() {
        /** @type {?} */
        let container_open = (/** @type {?} */ (this.help_box.querySelectorAll(".help-box.modal")[0]));
        /** @type {?} */
        let container_closed = (/** @type {?} */ (this.help_box.querySelectorAll(".help-button")[0]));
        /** @type {?} */
        let container = (this.help_box.classList.contains("hb-show")) ? container_open : container_closed;
        /** @type {?} */
        let container_height = container.offsetHeight;
        /** @type {?} */
        let filter = (/** @type {?} */ (document.querySelectorAll(".filter")[1]));
        /** @type {?} */
        let filter_height = filter.offsetHeight;
        /** @type {?} */
        let filter_position = filter.getBoundingClientRect().top + window.pageYOffset;
        return (window.pageYOffset + container_height) > filter_height + filter_position;
    }
    /**
     * @return {?}
     */
    passedFooter() {
        /** @type {?} */
        let footer = (/** @type {?} */ (document.querySelectorAll("app-footer")[0]));
        /** @type {?} */
        let footer_position = footer.getBoundingClientRect().top + window.pageYOffset;
        return (window.pageYOffset + window.innerHeight) > footer_position;
    }
    /**
     * @param {?} selector
     * @return {?}
     */
    getOffsetTop(selector) {
        /** @type {?} */
        let filter_top = selector.offsetTop;
        /** @type {?} */
        let traverse = selector.offsetParent;
        while (traverse) {
            filter_top += traverse.offsetTop;
            traverse = traverse.offsetParent;
        }
        return filter_top;
    }
    /**
     * @param {?} s
     * @param {?} metric
     * @return {?}
     */
    getMetric(s, metric) {
        /** @type {?} */
        let selector = document.querySelector(s);
        return parseInt(window.getComputedStyle(selector)[metric]);
    }
    /**
     * @return {?}
     */
    openHelp() {
        /** @type {?} */
        let help_btn = this.help_box.getElementsByClassName("help-button-btn")[0];
        if (help_btn) {
            help_btn.setAttribute("style", "opacity: 0;");
        }
        /** @type {?} */
        let helpWrapper = this.help_box.getElementsByClassName("help-wrapper")[0];
        if (helpWrapper) {
            if (this.isMobile) {
                helpWrapper.classList.add("in");
                helpWrapper.classList.add("mobile");
            }
            else {
                helpWrapper.classList.add("in");
                helpWrapper.classList.add("desktop");
                //Add styling
                /** @type {?} */
                let h1_bottom_offset = window.innerHeight - ((/** @type {?} */ (document.getElementsByTagName('h1')[0]))).offsetTop - 36;
                helpWrapper.setAttribute("style", "left: 0px; position: sticky; max-height: " + h1_bottom_offset + "px;");
            }
        }
    }
    /**
     * @return {?}
     */
    closeHelp() {
        /** @type {?} */
        let help_btn = this.help_box.getElementsByClassName("help-button-btn")[0];
        if (help_btn) {
            help_btn.setAttribute("style", "opacity: 1;");
        }
        /** @type {?} */
        let help_wrpr = this.help_box.getElementsByClassName("help-wrapper")[0];
        if (help_wrpr) {
            if (this.ayudaUiService.isDesktop) {
                help_wrpr.classList.remove("in");
                help_wrpr.classList.remove("desktop");
            }
            else {
                help_wrpr.classList.remove("in");
                help_wrpr.classList.remove("mobile");
            }
        }
    }
    /**
     * @return {?}
     */
    goBack() {
        this.ayudaUiService.movePages("backward");
    }
    /**
     * ********** Menu **************
     * @param {?} event
     * @return {?}
     */
    selectItem(event) {
        /** @type {?} */
        let target = event.target || event.srcElement || event.currentTarget;
        /** @type {?} */
        let clicked_item = target.closest(".menu-item");
        /** @type {?} */
        let item_page = clicked_item.dataset.item;
        /** @type {?} */
        let help_wrpr = this.help_box.getElementsByClassName("help-wrapper")[0];
        if (help_wrpr) {
            help_wrpr.classList.add(item_page);
        }
        this.ayudaUiService.loadComponent(this.getComponent(item_page), this.getComponentId(item_page));
    }
    /**
     * @param {?} name
     * @return {?}
     */
    getComponent(name) {
        /** @type {?} */
        let component = null;
        switch (true) {
            case (name === AyudaChannel.CallMeBack):
                component = AyudaCallMeBackComponent;
                //this.ayudaEventService.pushAyudaData("tellamamos");
                this.channelSelectionService.cmbChannelSelected();
                break;
            case (name === AyudaChannel.Email):
                component = AyudaEmailComponent;
                //this.eventService.pushAyudaData("email");
                this.channelSelectionService.emailChannelSelected();
                break;
        }
        return component;
    }
    /**
     * @param {?} name
     * @return {?}
     */
    getComponentId(name) {
        /** @type {?} */
        let id = "";
        switch (true) {
            case (name === AyudaChannel.CallMeBack):
                id = "callmeback-help";
                break;
            case (name === AyudaChannel.Email):
                id = "email-help";
                break;
        }
        return id;
    }
    /**
     * @return {?}
     */
    initiateWhatsApp() {
        this.ayudaUiService.initiateWhatsApp();
    }
    /**
     * @return {?}
     */
    initiateChat() {
        this.ayudaUiService.initiateChat();
    }
}
AyudaComponent.ɵfac = function AyudaComponent_Factory(t) { return new (t || AyudaComponent)(ɵngcc0.ɵɵdirectiveInject(AyudaService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(AyudaUiService), ɵngcc0.ɵɵdirectiveInject(ChannelSelectionService)); };
AyudaComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AyudaComponent, selectors: [["ras-ayuda-box"]], hostAttrs: [1, "help-button", "sticky", 2, "display", "block"], hostBindings: function AyudaComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("scroll", function AyudaComponent_scroll_HostBindingHandler($event) { return ctx.onScroll($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { displayMode: "displayMode", data: "data" }, decls: 7, vars: 1, consts: [["id", "help-button", 1, "help-button-btn", "btn", "help", 2, "opacity", "1", 3, "click"], [1, "btn-wrapper"], [1, "icon", "icon-question-circle", "visible-xs", "visible-sm"], [1, "icon", "icon-question-desktop", "hidden-xs", "hidden-sm"], [1, "help-wrapper"]], template: function AyudaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function AyudaComponent_Template_button_click_0_listener() { return ctx.openHelp(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelement(3, "span", 2)(4, "span", 3);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelement(6, "help-menu");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.title, " ");
    } }, dependencies: [AyudaMenuComponent], encapsulation: 2 });
/** @nocollapse */
AyudaComponent.ctorParameters = () => [
    { type: AyudaService },
    { type: ElementRef },
    { type: AyudaUiService },
    { type: ChannelSelectionService }
];
AyudaComponent.propDecorators = {
    displayMode: [{ type: Input }],
    data: [{ type: Input }],
    onScroll: [{ type: HostListener, args: ['window:scroll', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AyudaComponent, [{
        type: Component,
        args: [{
                selector: 'ras-ayuda-box',
                host: {
                    class: 'help-button sticky',
                    style: 'display:block'
                },
                template: "<!--boton de ayuda-->\r\n<button id=\"help-button\" class=\"help-button-btn btn help\" style=\"opacity:1\" (click)=\"openHelp()\">\r\n  <div class=\"btn-wrapper\">\r\n    <!--<span class=\"icon icon-question-circle\"></span>-->\r\n    {{title}}\r\n    <span class=\"icon icon-question-circle visible-xs visible-sm\"></span>\r\n    <span class=\"icon icon-question-desktop hidden-xs hidden-sm\"></span>\r\n  </div>\r\n</button>\r\n<!--caja de ayuda-->\r\n<div class=\"help-wrapper\">\r\n  <help-menu></help-menu>\r\n</div>\r\n"
            }]
    }], function () { return [{ type: AyudaService }, { type: ɵngcc0.ElementRef }, { type: AyudaUiService }, { type: ChannelSelectionService }]; }, { displayMode: [{
            type: Input
        }], 
    //@HostListener('window:resize', ['$event'])
    //onResize(event): void {
    //    this.setButtonTitle();
    //}
    /**
     * @param {?} event
     * @return {?}
     */
    onScroll: [{
            type: HostListener,
            args: ['window:scroll', ['$event']]
        }], data: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AyudaComponent.prototype.settingSub;
    /** @type {?} */
    AyudaComponent.prototype.element_position;
    /** @type {?} */
    AyudaComponent.prototype.help_box;
    /** @type {?} */
    AyudaComponent.prototype.title;
    /** @type {?} */
    AyudaComponent.prototype.isHelpSectionEnabled;
    /** @type {?} */
    AyudaComponent.prototype.h1_height;
    /** @type {?} */
    AyudaComponent.prototype.bottomHeight;
    /**
     * @type {?}
     * @private
     */
    AyudaComponent.prototype.dispMode;
    /** @type {?} */
    AyudaComponent.prototype.data;
    /** @type {?} */
    AyudaComponent.prototype.scroll;
    /**
     * @type {?}
     * @private
     */
    AyudaComponent.prototype.ayudaService;
    /** @type {?} */
    AyudaComponent.prototype.elementRef;
    /** @type {?} */
    AyudaComponent.prototype.ayudaUiService;
    /**
     * @type {?}
     * @private
     */
    AyudaComponent.prototype.channelSelectionService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NumbersOnlyInput {
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyDown(event) {
        //Keys allowed for editing
        /** @type {?} */
        const allowedKeys = ["Control", "Shift", "Tab", "Backspace", "Insert", "Delete", "Home", "End", "Escape", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];
        //Also check if key is not a NaN.
        if (allowedKeys.indexOf(event.key) > -1 || !isNaN(parseInt(event.key))) {
            return true;
        }
        else {
            event.preventDefault();
        }
    }
}
NumbersOnlyInput.ɵfac = function NumbersOnlyInput_Factory(t) { return new (t || NumbersOnlyInput)(); };
NumbersOnlyInput.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NumbersOnlyInput, selectors: [["", "numbersOnly", ""]], hostBindings: function NumbersOnlyInput_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function NumbersOnlyInput_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } }, inputs: { numbersOnly: "numbersOnly" } });
NumbersOnlyInput.propDecorators = {
    numbersOnly: [{ type: Input }],
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NumbersOnlyInput, [{
        type: Directive,
        args: [{
                selector: '[numbersOnly]'
            }]
    }], null, { 
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], numbersOnly: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    NumbersOnlyInput.prototype.numbersOnly;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RasAyudaModule {
}
RasAyudaModule.ɵfac = function RasAyudaModule_Factory(t) { return new (t || RasAyudaModule)(); };
RasAyudaModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: RasAyudaModule });
RasAyudaModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        RegexValidationService,
        PhoneValidationService,
        EmailValidationService,
        AyudaService,
        AyudaEventService,
        AyudaUiService,
        ValidationService,
        InputValidationService,
        ChannelSelectionService
    ], imports: [CommonModule,
        FormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RasAyudaModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AyudaComponent,
                    AyudaMenuComponent,
                    AyudaCallMeBackComponent,
                    AyudaEmailComponent,
                    AyudaFinishComponent,
                    AyudaTermsComponent,
                    NumbersOnlyInput
                ],
                imports: [
                    CommonModule,
                    FormsModule
                ],
                entryComponents: [
                    AyudaMenuComponent,
                    AyudaCallMeBackComponent,
                    AyudaEmailComponent,
                    AyudaFinishComponent
                ],
                providers: [
                    RegexValidationService,
                    PhoneValidationService,
                    EmailValidationService,
                    AyudaService,
                    AyudaEventService,
                    AyudaUiService,
                    ValidationService,
                    InputValidationService,
                    ChannelSelectionService
                ],
                exports: [
                    AyudaComponent,
                    AyudaMenuComponent,
                    AyudaCallMeBackComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RasAyudaModule, { declarations: function () { return [AyudaComponent, AyudaMenuComponent, AyudaCallMeBackComponent, AyudaEmailComponent, AyudaFinishComponent, AyudaTermsComponent, NumbersOnlyInput]; }, imports: function () { return [CommonModule,
        FormsModule]; }, exports: function () { return [AyudaComponent, AyudaMenuComponent, AyudaCallMeBackComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AyudaChannel, AyudaEventService, AyudaFormDataModel, AyudaFormSubmitEvent, AyudaService, RasAyudaModule, AyudaComponent as ɵa, AyudaUiService as ɵb, ChannelSelectionService as ɵc, AyudaMenuComponent as ɵd, AyudaCallMeBackComponent as ɵe, InputValidationService as ɵf, ValidationService as ɵg, RegexValidationService as ɵh, EmailValidationService as ɵi, PhoneValidationService as ɵj, AyudaEmailComponent as ɵk, AyudaFinishComponent as ɵl, AyudaConfig as ɵm, AyudaTermsComponent as ɵn, NumbersOnlyInput as ɵo };

